/*
 * Module for the Member Direct Enrollment PIN Letters criteria page
 */
rs.module("content/jobs/criteria/memberdirectenrollmentpinletters",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, enrollmentOptions, memberRoleStatuses, deliveryOptions, availablePrinters, preferredPrinter) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var recipientSelect = criteria.js(jsSelectors.recipientSelect);

            var memberStatusSection = criteria.js(jsSelectors.memberStatusSection);
            var newHireSection = criteria.js(jsSelectors.newHireSection);
            var newBenefitReceipientSection = criteria.js(jsSelectors.newBenefitReceipientSection);

            var roleStatusSelect = criteria.js(jsSelectors.roleStatusSelect);
            var newHireDateInput = criteria.js(jsSelectors.newHireDateInput);
            var newBenefitRecipientDateInput = criteria.js(jsSelectors.newBenefitRecipientDateInput);

            var skipReviewCheckBox = criteria.js(jsSelectors.skipReviewCheckBox);
            var deliveryMethodSelect = criteria.js(jsSelectors.deliveryMethodSelect);
            var printersSelect = criteria.js(jsSelectors.printersSelect);

            // Get Select Helper(s) to update the options and properties.
            var roleStatusSelectHelper = selectHelper.getHelper(roleStatusSelect);
            var deliveryMethodSelectHelper = selectHelper.getHelper(deliveryMethodSelect);
            var printersSelectHelper = selectHelper.getHelper(printersSelect);

            // Change available inputs based on the selected recipient criteria
            recipientSelect.change(function () {
                showHideRecipientFields();
            });

            // disable the printers dropdown based on the skip Review check box
            skipReviewCheckBox.change(function () {
                enableDisableSkipReviewFields();
            });

            // Show or Hide fields based on the selected recipient group
            function showHideRecipientFields() {

                // Hide all
                visibility.hide(memberStatusSection);
                visibility.hide(newHireSection);
                visibility.hide(newBenefitReceipientSection);

                // Clear and disable criteria input fields
                resetInputFields();

                switch (recipientSelect.val()) {
                    case enrollmentOptions.roleStatus:
                        visibility.show(memberStatusSection);
                        roleStatusSelectHelper.setDisabled(false);
                        roleStatusSelectHelper.replaceOptions(memberRoleStatuses);
                        break;

                    case enrollmentOptions.newHires:
                        visibility.show(newHireSection);
                        newHireDateInput.prop('disabled', false);
                        break;

                    case enrollmentOptions.newBenefitRecipients:
                        visibility.show(newBenefitReceipientSection);
                        newBenefitRecipientDateInput.prop('disabled', false);
                        break;

                    default:
                        break;
                }
            };

            // Enable or disable fields related to the skip review flag
            function enableDisableSkipReviewFields() {

                if (skipReviewCheckBox.is(":checked")) {

                    //enable and re-populate delivery method select
                    deliveryMethodSelectHelper.setDisabled(false);
                    deliveryMethodSelectHelper.replaceOptions(deliveryOptions);

                    //enable and re-populate printer select
                    printersSelectHelper.setDisabled(false);
                    printersSelectHelper.replaceOptions(availablePrinters);

                    // Since we have reloaded options, we should again default to the user's preferred Printer
                    if (preferredPrinter != '') {
                        printersSelectHelper.setValue(preferredPrinter);
                    }
                }
                else {
                    //disable and clear delivery method select
                    deliveryMethodSelectHelper.clearOptions();
                    deliveryMethodSelectHelper.setDisabled(true);

                    //disable and clear printer select
                    printersSelectHelper.clearOptions();
                    printersSelectHelper.setDisabled(true);
                }
            }

            // Clear inputs and remove validation messages
            function resetInputFields() {
                [
                    newHireDateInput,
                    newBenefitRecipientDateInput
                ].forEach((input) => input.clearErrors().val('').prop('disabled', true));

                //disable and clear inputs
                roleStatusSelectHelper.clearOptions();
                roleStatusSelectHelper.setDisabled(true);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);